import React from 'react';

import { staticDispatch } from '#/reduxState/store';
import { useSelector } from '#/reduxState/storeCore';
import { showDesktopQRConnectModal } from '#/reduxState/wallet/walletDetailsReducer';

import QrSyncModalDesktop from './QrSyncModalDesktop';

export default function QrSyncDesktop() {
  const { desktopQrConnectModal } = useSelector(state => state.walletDetail);
  if (!desktopQrConnectModal) {
    return null;
  }
  return (
    <QrSyncModalDesktop
      doNotShowAgainOption={desktopQrConnectModal !== 'withoutDoNotShowAgain'}
      onClose={() => staticDispatch(showDesktopQRConnectModal(false))}
    />
  );
}
